module.exports = __webpack_public_path__ + "81a8aeddb9ba19a78dee4ead021a9e91.png";